module.exports = __webpack_public_path__ + "img/MOLOKO.3ac30030.svg";